import React, { useMemo } from 'react';
import Modal from '../../../../components/Modal/modal';
import useRetainerRequest, { initialRetainerRequest } from '../../../../hooks/useRetainerRequest';
import ReadOnlyPrescription from '../ReadOnlyPrescription/readOnlyPrescription';
import { CircularProgress, Grid } from '@material-ui/core';
import AnswerGrid from '../ReadOnlyPrescription/answerGrid';
import { questions } from '../../Question';
import { useLang } from '../../../../util/lang';

const ViewPrescriptionModal = ({ open = false, retainerRequestId = 0, handleClose }) => {
    const { retainerRequest, setRetainerRequest, loading } = useRetainerRequest({
        retainerRequestId: retainerRequestId,
    });
    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
        setRetainerRequest(initialRetainerRequest);
    };
    const get = useLang();

    const prescriptionValue = useMemo(() => {
        if (!retainerRequest.caseId)
            return {
                upperPart: null,
                lowerPart: null,
                caseImpression: null,
                specialInstruction: '',
            };

        return {
            upperPart: {
                upperBiteRamp: retainerRequest.upperBiteRamp,
                upperBleachingRetainersSelect: retainerRequest.upperBleachingRetainersSelect,
                upperClearRetainerDesignLowerOption: retainerRequest.upperClearRetainerDesignLowerOption,
                upperClearRetainerDesignLowerOptionForSecondSet:
                    retainerRequest.upperClearRetainerDesignLowerOptionForSecondSet,
                upperClearRetainerDesignUpperOption: retainerRequest.upperClearRetainerDesignUpperOption,
                upperClearRetainerDesignUpperOptionForSecondSet:
                    retainerRequest.upperClearRetainerDesignUpperOptionForSecondSet,
                // upperFixedPalatalWireSelect: retainerRequest.upperFixedPalatalWireSelect,
                upperWireSelect: retainerRequest.upperWireSelect,
                upperFixedWire: retainerRequest.upperFixedWire,
                upperPontics: retainerRequest.upperPontics,
                upperRetainerTypeId: retainerRequest.upperRetainerTypeId,
                upperJigPlacementSelect: retainerRequest.upperJigPlacementSelect,

                upperPontic: retainerRequest.upperPontic,
                upperPonticColor: retainerRequest.upperPonticColor,
                upperLowTrimlineAreaSelect_3: retainerRequest.upperLowTrimlineAreaSelect_3,
                upperLowTrimlineAreaSelect_1: retainerRequest.upperLowTrimlineAreaSelect_1
            },
            lowerPart: {
                lowerBiteRamp: retainerRequest.lowerBiteRamp,
                lowerBleachingRetainersSelect: retainerRequest.lowerBleachingRetainersSelect,
                lowerClearRetainerDesignLowerOption: retainerRequest.lowerClearRetainerDesignLowerOption,
                lowerClearRetainerDesignLowerOptionForSecondSet:
                    retainerRequest.lowerClearRetainerDesignLowerOptionForSecondSet,
                lowerClearRetainerDesignUpperOption: retainerRequest.lowerClearRetainerDesignUpperOption,
                lowerClearRetainerDesignUpperOptionForSecondSet:
                    retainerRequest.lowerClearRetainerDesignUpperOptionForSecondSet,
                // lowerFixedPalatalWireSelect: retainerRequest.lowerFixedPalatalWireSelect,
                lowerWireSelect: retainerRequest.lowerWireSelect,
                lowerFixedWire: retainerRequest.lowerFixedWire,
                lowerPontics: retainerRequest.lowerPontics,
                lowerRetainerTypeId: retainerRequest.lowerRetainerTypeId,
                lowerJigPlacementSelect: retainerRequest.lowerJigPlacementSelect,

                lowerPontic: retainerRequest.lowerPontic,
                lowerPonticColor: retainerRequest.lowerPonticColor,
                lowerLowTrimlineAreaSelect_3: retainerRequest.lowerLowTrimlineAreaSelect_3,
                lowerLowTrimlineAreaSelect_1: retainerRequest.lowerLowTrimlineAreaSelect_1
            },
            specialInstruction: retainerRequest.specialInstruction,
            caseImpression: retainerRequest.caseImpression,
        };
    }, [retainerRequest]);

    const displayNoData = useMemo(() => {
        return (
            !loading &&
            !prescriptionValue.upperPart &&
            !prescriptionValue.lowerPart &&
            !prescriptionValue.caseImpression
        );
    }, [prescriptionValue, loading]);

    const children = useMemo(() => {
        if (displayNoData) {
            return (
                <Grid item style={{ display: 'grid', placeContent: 'center' }}>
                    <p>No Data Available</p>
                </Grid>
            );
        }

        return (
            <>
                <Grid item>
                    {prescriptionValue.upperPart && prescriptionValue.upperPart.upperRetainerTypeId > 0 && (
                        <ReadOnlyPrescription impressionType={'upper'} prescription={prescriptionValue.upperPart} />
                    )}
                </Grid>
                <Grid item>
                    {prescriptionValue.lowerPart && prescriptionValue.lowerPart.lowerRetainerTypeId > 0 && (
                        <ReadOnlyPrescription impressionType={'lower'} prescription={prescriptionValue.lowerPart} />
                    )}
                </Grid>

                {/* {Q8. File Upload} */}
                <ul>
                    {prescriptionValue.caseImpression && (
                        <li>
                            <Grid item style={{ marginTop: 12 }}>
                                <Grid>
                                    {/* <p>{questions[8].name}</p> */}
                                    <p>{get(`@DiffRetainer.formQuestionLabel.${questions[8]?.name}`)}</p>
                                </Grid>
                                <Grid>
                                    <AnswerGrid field={'impressionOption'} value={prescriptionValue.caseImpression} />
                                </Grid>
                            </Grid>
                        </li>
                    )}

                    <li>
                        <Grid item style={{ marginTop: 12 }}>
                            <Grid>
                                {/* <p>{questions[9].name}</p> */}
                                <p> {get('@NewPatient.prescriptionNotes.specialInstructionsDescription')}</p>
                            </Grid>
                            <Grid>
                                <AnswerGrid field={'specialInstruction'} value={prescriptionValue.specialInstruction} />
                            </Grid>
                        </Grid>
                    </li>
                </ul>
            </>
        );
    }, [prescriptionValue, displayNoData]);

    return (
        <Modal handleClose={onClose} open={open} title={get('@PatientInfo.case_info.documentsList.viewQuestionnaire')}>
            <Grid container direction="column">
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ height: 600 }}>
                            <CircularProgress style={{ color: 'blueviolet' }} />
                        </div>
                    </div>
                ) : (
                    <>{children}</>
                )}
            </Grid>
        </Modal>
    );
};

export default ViewPrescriptionModal;
